export function NwFooter() {
  return (
    <footer className="mt-auto text-white" style={{ background: 'var(--color-nw-charcoal)' }}>
      <div className="max-w-4xl mx-auto px-4 py-6 text-center text-sm space-y-2">
        <img
          src="/newwestern-white.svg"
          alt="New Western"
          className="h-6 mx-auto opacity-90"
        />
        <p className="text-gray-300">
          Questions? Contact us at{' '}
          <a href="mailto:support@quickdrawfunding.com" className="text-white hover:underline">
            support@quickdrawfunding.com
          </a>
        </p>
        <p className="text-gray-400 text-xs">
          By submitting this form you agree to our{' '}
          <a href="#" className="text-gray-300 hover:underline">
            Privacy Policy
          </a>{' '}
          and{' '}
          <a href="#" className="text-gray-300 hover:underline">
            Terms of Service
          </a>
          .
        </p>
        <p className="text-gray-400 text-xs pt-2 border-t border-gray-700">
          &copy; {new Date().getFullYear()} New Western. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
